import Step2FabRegistrationContent from "./Steps/Step2FabRegistrationContent.jsx";
import Step2FabYouthContent from "./Steps/Step2FabYouthContent.jsx";
import Step2FabHomepageContent from "./Steps/Step2FabHomepageContent.jsx";
import Step2FabFootageContent from "./Steps/Step2FabFootageContent.jsx";
import Step2FabOurTeamContent from "./Steps/Step2FabOurTeamContent.jsx";
import Step2FabInfoContent from "./Steps/Step2FabInfoContent.jsx";
import Step2FabTournamentContent from "./Steps/Step2FabTournamentContent.jsx";

import FabHomepage from "./Templates/FabHomepage.jsx";
import FabRegistration from "./Templates/FabRegistration.jsx";
import FabFootage from "./Templates/FabFootage.jsx";
import FabYouth from "./Templates/FabYouth.jsx";
import FabOurTeam from "./Templates/FabOurTeam.jsx";
import FabInfo from "./Templates/FabInfo.jsx";
import FabTournament from "./Templates/FabTournament.jsx";

import fabHomepageEditorConfig from "./EditorConfigs/fabHomepageEditorConfig.js";
import fabTournamentEditorConfig from "./EditorConfigs/fabTournamentEditorConfig.js";
import fabYouthEditorConfig from "./EditorConfigs/fabYouthEditorConfig.js";
import fabOurTeamEditorConfig from "./EditorConfigs/fabOurTeamEditorConfig.js";
import fabInfoEditorConfig from "./EditorConfigs/fabInfoEditorConfig.js";
import fabRegistrationEditorConfig from "./EditorConfigs/fabRegistrationEditorConfig.js";
import fabFootageEditorConfig from "./EditorConfigs/fabFootageEditorConfig.js";

const fabTemplates = {
  "fab-homepage": {
    id: "fab-homepage",
    name: "FAB-Homepage",
    label: "FAB",
    desc: "Bold hero + custom sections",
    pageType: "home",
    step2Component: Step2FabHomepageContent,
    publicComponent: FabHomepage,
      editorConfig: fabHomepageEditorConfig,
  },

  "fab-tournament": {
    id: "fab-tournament",
    name: "FAB-Tournament",
    label: "FAB Tournament",
    desc: "FAB tournament page",
    pageType: "page",
    step2Component: Step2FabTournamentContent,
    publicComponent: FabTournament,
    editorConfig: fabTournamentEditorConfig,
  },

  "fab-youth": {
    id: "fab-youth",
    name: "FAB-Youth",
    label: "FAB Youth",
    desc: "FAB youth information page",
    pageType: "page",
    step2Component: Step2FabYouthContent,
    publicComponent: FabYouth,
    editorConfig: fabYouthEditorConfig,
  },

  "fab-our-team": {
    id: "fab-our-team",
    name: "FAB-Our-Team",
    label: "FAB Our team",
    desc: "FAB our team page",
    pageType: "page",
    step2Component: Step2FabOurTeamContent,
    publicComponent: FabOurTeam,
    editorConfig: fabOurTeamEditorConfig,
  },

  "fab-info": {
    id: "fab-info",
    name: "FAB-Info",
    label: "FAB Info",
    desc: "FAB info page",
    pageType: "page",
    step2Component: Step2FabInfoContent,
    publicComponent: FabInfo,
    editorConfig: fabInfoEditorConfig,
  },

  "fab-registration": {
    id: "fab-registration",
    name: "FAB-Registration",
    label: "FAB Registration",
    desc: "FAB registration landing page",
    pageType: "page",
    step2Component: Step2FabRegistrationContent,
    publicComponent: FabRegistration,
    editorConfig: fabRegistrationEditorConfig,
  },

  "fab-footage": {
    id: "fab-footage",
    name: "FAB-Footage",
    label: "FAB Footage",
    desc: "FAB footage media page",
    pageType: "page",
    step2Component: Step2FabFootageContent,
    publicComponent: FabFootage,
    editorConfig: fabFootageEditorConfig,
  },
};

export default fabTemplates;